import React, { Component, Fragment } from "react";
import withRouter from "../../withRouter/withRouter";

import "./Coupon.css";
import { toPersianNumber } from "../../../classes/utils";

const monthes = [
    { name: "فروردین", value: 1 },
    { name: "اردیبهشت", value: 2 },
    { name: "خرداد", value: 3 },
    { name: "تیر", value: 4 },
    { name: "مرداد", value: 5 },
    { name: "شهریور", value: 6 },
    { name: "مهر", value: 7 },
    { name: "آبان", value: 8 },
    { name: "آذز", value: 9 },
    { name: "دی", value: 10 },
    { name: "بهمن", value: 11 },
    { name: "اسفند", value: 12 },
];

class Coupon extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.effectFormRef = React.createRef();
        this.expireFormRef = React.createRef();
        this.addUserInRef = React.createRef();
        this.addItemInRef = React.createRef();

        this.add_certain_user = this.add_certain_user.bind(this);
        this.add_certain_item = this.add_certain_item.bind(this);
        this.request_data = this.request_data.bind(this);
        this.save = this.save.bind(this);
        this.effect_output = this.effect_output.bind(this);
        this.expire_output = this.expire_output.bind(this);

        this.updating = this.props.router.params.code ? true : false;
    }

    componentDidMount() {
        this.request_data();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.coupon != this.state.coupon) {
            this.effect_output();
            this.expire_output();
        }
    }

    request_data() {
        let { connection, router, toast } = this.props;
        let { code } = router.params;

        if (code) {
            connection
                .get_filtered_data("coupons", { code })
                .then((res) => {
                    let coupon = res.data.coupons[0];
                    this.setState({
                        coupon,
                        for_certain_users: coupon.target.users ? true : false,
                        certain_users_list: coupon.target.users,
                        hasExpire: coupon.expire ? true : false,
                    });
                })
                .catch((err) => {
                    toast(
                        "دریافت اطلاعات کد تخفیف",
                        " خطا در دریافت اطلاعات کد تخفیف" + err,
                        " danger"
                    );
                });
        }

        connection
            .get_filtered_data("items")
            .then((res) => {
                this.setState({ itemsList: res.data.items });
            })
            .catch((err) => {
                toast(
                    "دریافت اطلاعات کالا ها",
                    " خطا در دریافت اطلاعات کالا ها" + err,
                    " danger"
                );
            });

        connection
            .getAllCategories()
            .then((res) => {
                this.setState({ categories: res.data });
            })
            .catch((err) => {
                toast(
                    "دریافت اطلاعات دسته بندی ها",
                    " خطا در دریافت اطلاعات دسته بندی ها" + err,
                    " danger"
                );
            });
    }

    add_certain_user() {
        let { certain_users_list } = this.state;

        certain_users_list = certain_users_list || [];
        certain_users_list.push(this.addUserInRef.current.value);
        this.addUserInRef.current.value = "";
        this.setState({
            certain_users_list,
        });
    }

    add_certain_item() {
        let { certain_items_list, itemsList } = this.state;
        let { toast } = this.props;

        certain_items_list = certain_items_list || [];
        if (
            !itemsList.find((i) => {
                return this.addItemInRef.current.value == i.id;
            })
        ) {
            toast("افزودن کالا", "کالا یافت نشد", " danger");
            return;
        }
        certain_items_list.push(this.addItemInRef.current.value);
        this.addItemInRef.current.value = "";
        this.setState({
            certain_items_list,
        });
    }

    save() {
        let { certain_users_list, coupon } = this.state;
        let { connection, toast, router } = this.props;
        let formData = Object.fromEntries(new FormData(this.formRef.current));

        let effectFormdata = Object.fromEntries(
            new FormData(this.effectFormRef.current)
        );
        let expireFormdata = this.expireFormRef.current
            ? Object.fromEntries(new FormData(this.expireFormRef.current))
            : {};

        let {
            code,
            certain_users,
            totalItemsPriceMoreThan,
            active,
            hasExpire,
            limit,
        } = formData;

        if (code == "" || code.length < 3) {
            toast(
                "چک ورودی ها",
                "کد تخفیف نمیتواند خالی باید و باید حداقل 3 کاراکتر داشته باشد",
                " danger"
            );
            return;
        }

        let {
            packingCostEffectType,
            packingCostEffectValue,
            shippingCostEffectType,
            shippingCostEffectValue,
            totalItemsPriceEffectType,
            totalItemsPriceEffectValue,
        } = effectFormdata;

        packingCostEffectValue = parseInt(packingCostEffectValue) || 0;
        shippingCostEffectValue = parseInt(shippingCostEffectValue) || 0;
        totalItemsPriceEffectValue = parseInt(totalItemsPriceEffectValue) || 0;

        if (
            packingCostEffectValue < 0 ||
            shippingCostEffectValue < 0 ||
            totalItemsPriceEffectValue < 0
        ) {
            toast(
                "چک ورودی ها",
                "ورودی های میزان تاثیر تخفیف نمیتوانند کمتر از صفر باشند. ورودی هایی که کادر آنها قرمز شده را بازبینی کنید",
                " danger",
                10000
            );
            return;
        }
        if (
            packingCostEffectValue == 0 &&
            shippingCostEffectValue == 0 &&
            totalItemsPriceEffectValue == 0
        ) {
            toast(
                "چک ورودی ها",
                "حداقل یک تاثیر برای کد تخفیف وارد کنید.",
                " danger"
            );
            return;
        }

        if (
            (packingCostEffectType == "percent" &&
                packingCostEffectValue > 100) ||
            (shippingCostEffectType == "percent" &&
                shippingCostEffectValue > 100) ||
            (totalItemsPriceEffectType == "percent" &&
                totalItemsPriceEffectValue > 100)
        ) {
            toast(
                "چک ورودی ها",
                "موارد تاثیر نمیتوانند بیش تر از 100 درصد باشند",
                " danger"
            );
            return;
        }
        let update = false;

        coupon ? (update = true) : (coupon = {});

        coupon.code = code;

        coupon.target = {
            users: certain_users && certain_users_list,
            minCart: totalItemsPriceMoreThan,
        };
        coupon.effect = {
            packing: {
                type: packingCostEffectType,
                value: packingCostEffectValue,
            },
            shipping: {
                type: shippingCostEffectType,
                value: shippingCostEffectValue,
            },
            cart: {
                type: totalItemsPriceEffectType,
                value: totalItemsPriceEffectValue,
            },
        };

        coupon.active = active ? true : false;
        let { hour, day, month, year } = expireFormdata;
        let ex =
            ((parseInt(hour) || 0) +
                (parseInt(day) * 24 || 0) +
                (parseInt(month) * 24 * 30 || 0) +
                (parseInt(year) * 24 * 365 || 0)) *
            60 *
            60 *
            1000;
        coupon.expire =
            hasExpire && ex > 0
                ? Date.now() + ex
                : coupon.expire && coupon.expire > 0
                ? coupon.expire
                : null;
        coupon.limit = limit;

        update
            ? connection
                  .update_coupon(coupon)
                  .then((res) => {
                      toast(
                          "بروزرسانی کد تخفیف",
                          "کد تخفیف با موفقیت بروزرسانی شد",
                          " confirm"
                      );
                      window.location.reload();
                      //router.navigate("/coupon/code/" + code);
                  })
                  .catch((err) => {
                      toast(
                          "بروزرسانی کد تخفیف",
                          "خطا در بروزرسانی کد تخفیف" + err,
                          " danger"
                      );
                  })
            : connection
                  .send_coupon(coupon)
                  .then((res) => {
                      toast(
                          "ثبت کد تخفیف",
                          "کد تخفیف با موفقیت ثبت شد",
                          " confirm"
                      );
                      router.navigate("/coupon/code/" + code);
                  })
                  .catch((err) => {
                      toast(
                          "ثبت کد تخفیف",
                          "خطا در ثبت کد تخفیف" + err,
                          " danger"
                      );
                  });
    }

    effect_output() {
        let effectFormdata = Object.fromEntries(
            new FormData(this.effectFormRef.current)
        );
        let {
            packingCostEffectType,
            packingCostEffectValue,
            shippingCostEffectType,
            shippingCostEffectValue,
            totalItemsPriceEffectType,
            totalItemsPriceEffectValue,
        } = effectFormdata;

        packingCostEffectValue = parseInt(packingCostEffectValue) || 0;
        shippingCostEffectValue = parseInt(shippingCostEffectValue) || 0;
        totalItemsPriceEffectValue = parseInt(totalItemsPriceEffectValue) || 0;

        let output = [];

        totalItemsPriceEffectValue > 0 &&
            output.push(
                `${toPersianNumber(totalItemsPriceEffectValue, true)} ${
                    totalItemsPriceEffectType === "percent" ? "درصد " : "تومان "
                } تخفیف بر روی قیمت کل اجناس `
            );

        packingCostEffectValue > 0 &&
            output.push(
                `${toPersianNumber(packingCostEffectValue, true)} ${
                    packingCostEffectType === "percent" ? "درصد " : "تومان "
                } تخفیف بر روی هزینه بسته بندی `
            );

        shippingCostEffectValue > 0 &&
            output.push(
                `${toPersianNumber(shippingCostEffectValue, true)} ${
                    shippingCostEffectType === "percent" ? "درصد " : "تومان "
                } تخفیف بر روی هزینه ارسال `
            );

        this.setState({ effectRes: output.join("  و ") });
    }

    expire_output() {
        let { coupon } = this.state;
        let expireFormdata = this.expireFormRef.current
            ? Object.fromEntries(new FormData(this.expireFormRef.current))
            : {};

        let { hour, day, month, year } = expireFormdata;

        hour = parseInt(hour) || 0;
        day = parseInt(day) || 0;
        month = parseInt(month) || 0;
        year = parseInt(year) || 0;

        let ex;
        //if inputs are nor empty
        if (hour != 0 || day != 0 || month != 0 || year != 0) {
            ex =
                (hour + day * 24 + month * 24 * 30 + year * 24 * 365) *
                60 *
                60 *
                1000;
            ex =
                ex > 0
                    ? new Date(Date.now() + ex).toLocaleString("fa-IR")
                    : null;

            this.setState({ expireRes: ex });
        } else if (coupon) {
            //if inputs are empty and there is a coupon
            ex =
                coupon.expire &&
                new Date(coupon.expire).toLocaleString("fa-IR");
            this.setState({ expireRes: ex });
        }
    }

    state = {
        coupon: null,
        hasExpire: false,
        for_certain_users: false,
        certain_users_list: null,
        for_certain_items: false,
        certain_items_list: null,
        itemsList: null,
        categories: null,
        effectRes: null,
        expireRes: null,
    };

    render() {
        let {
            coupon,
            hasExpire,
            for_certain_users,
            certain_users_list,
            for_certain_items,
            certain_items_list,
            itemsList,
            categories,
            effectRes,
            expireRes,
        } = this.state;

        let { effect, target, expire, code, active, limit } = coupon || {};
        return (
            <div className="CouponComponent">
                <form id="form" ref={this.formRef}></form>
                <div className="code ">
                    <div className="caption">
                        <i className="fa-solid fa-key"></i>
                        کد
                    </div>
                    <i className="ri-coupon-3-fill "></i>
                    کد تخفیف
                    <input
                        type="text"
                        name="code"
                        form="form"
                        defaultValue={code}
                        required
                        minLength={3}
                    />
                    <span className="text info">(اجباری)</span>
                    <span className="attention text danger">
                        <i className="ri-error-warning-line"></i>
                        حداقل 3 کاراکتر
                    </span>
                </div>
                <div className="target">
                    <div className="caption">
                        <i className="fa-solid fa-bullseye"></i>
                        هدف
                    </div>
                    <span className="attention text danger">
                        <i className="ri-questionnaire-fill"></i>
                        اگر هیچ هدفی مشخص نشود تخفیف بر روی تمام سفارشات اعمال
                        می شود.
                    </span>
                    <div className="for_certain_users">
                        <div className="caption">
                            <i className="ri-user-line"></i>
                            فقط برای کاربران خاص ؟
                            <input
                                type="checkbox"
                                name="certain_users"
                                onChange={(ev) =>
                                    this.setState({
                                        for_certain_users: ev.target.checked,
                                    })
                                }
                                form="form"
                                checked={for_certain_users}
                            />
                        </div>
                        {for_certain_users && (
                            <Fragment>
                                <div className="add_user text primary">
                                    شماره موبایل کاربر :
                                    <input type="tel" ref={this.addUserInRef} />
                                    <button
                                        className="add btn info"
                                        onClick={this.add_certain_user}
                                    >
                                        <i className="fa-solid fa-plus"></i>
                                    </button>
                                </div>
                                {certain_users_list && (
                                    <div className="users text info">
                                        کاربران
                                        {certain_users_list.map((user, i) => {
                                            return (
                                                <div
                                                    className="user text info"
                                                    key={i}
                                                >
                                                    <div className="mobile text secondary">
                                                        {user}
                                                    </div>
                                                    <button className="delete_user btn danger">
                                                        <i className="fa-solid fa-minus"></i>
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </Fragment>
                        )}
                    </div>
                    {false && (
                        <div className="for_certain_items">
                            <div className="caption">
                                فقط برای کالاهای خاص ؟
                                <input
                                    type="checkbox"
                                    name="certain_items"
                                    onChange={(ev) =>
                                        this.setState({
                                            for_certain_items:
                                                ev.target.checked,
                                        })
                                    }
                                    defaultChecked={
                                        coupon && coupon.for_certain_items
                                    }
                                />
                            </div>
                            {for_certain_items && (
                                <Fragment>
                                    {categories && categories.length ? (
                                        <div className="categories">
                                            {categories.map((cat) => {
                                                return (
                                                    <div className="category">
                                                        <input
                                                            type="checkbox"
                                                            name={
                                                                "categoty_" +
                                                                cat.name
                                                            }
                                                            defaultChecked={
                                                                coupon &&
                                                                coupon.for_certain_items &&
                                                                coupon.categories.include(
                                                                    cat.name
                                                                )
                                                            }
                                                        />
                                                        <img src={cat.image} />
                                                        <div className="name">
                                                            {cat.name}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="loading">
                                            در حال دریافت لیست دسته بندی ها
                                        </div>
                                    )}

                                    {itemsList ? (
                                        <Fragment>
                                            <div className="add_item text secondary">
                                                کد کالا :
                                                <input
                                                    type="text"
                                                    ref={this.addItemInRef}
                                                    list="itemsList"
                                                />
                                                <datalist
                                                    id="itemsList"
                                                    style={{ display: "none" }}
                                                >
                                                    {itemsList &&
                                                        itemsList.length > 0 &&
                                                        itemsList.map(
                                                            (item) => {
                                                                return (
                                                                    <option
                                                                        value={
                                                                            item.id
                                                                        }
                                                                    >
                                                                        {
                                                                            item.name
                                                                        }
                                                                    </option>
                                                                );
                                                            }
                                                        )}
                                                </datalist>
                                                <button
                                                    className="add btn info"
                                                    onChange={
                                                        this.add_certain_item
                                                    }
                                                >
                                                    <i className="fa-solid fa-plus"></i>
                                                </button>
                                            </div>
                                            {certain_items_list && (
                                                <div className="items text info">
                                                    کالاها
                                                    {certain_items_list.map(
                                                        (item, i) => {
                                                            return (
                                                                <div
                                                                    className="item text info"
                                                                    key={i}
                                                                >
                                                                    <div className="name text secondary">
                                                                        {item}
                                                                    </div>
                                                                    <button className="delete_item btn danger">
                                                                        <i className="fa-solid fa-minus"></i>
                                                                    </button>
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            )}
                                        </Fragment>
                                    ) : (
                                        <div className="loading">
                                            درحال دریافت لیست کالا ها
                                        </div>
                                    )}
                                </Fragment>
                            )}
                        </div>
                    )}
                    <div className="conditions">
                        <div className="condition text info">
                            قیمت کل اجناس بیشتر از
                            <input
                                type="number"
                                name="totalItemsPriceMoreThan"
                                form="form"
                                defaultValue={
                                    this.updating
                                        ? target && parseInt(target.minCart)
                                        : 0
                                }
                                min={0}
                            />
                            تومان باشد.
                        </div>
                    </div>
                </div>
                <div className="effects">
                    <div className="caption">
                        <i className="fa-solid fa-hurricane"></i>
                        تاثیر
                    </div>
                    <span className="help text info">
                        <i className="ri-questionnaire-fill"></i>
                        برای مثال :
                        <span className=" text primary">20 درصد تخفیف</span>
                        روی قیمت کل اجناس
                        <span className="text secondary">یا</span>
                        <span className=" text primary">
                            200,000 هزار تومان
                        </span>
                        تخفیف بر روی هزینه ارسال
                    </span>
                    <form id="effectForm" ref={this.effectFormRef}></form>
                    <div className="effect totalItemsPriceEffect">
                        <i className="fa-solid fa-border-all"></i>
                        تخفیف روی قیمت کل اجناس
                        <input
                            type="number"
                            min={0}
                            name="totalItemsPriceEffectValue"
                            form="effectForm"
                            defaultValue={
                                this.updating
                                    ? effect && effect.cart && effect.cart.value
                                    : 0
                            }
                            onChange={this.effect_output}
                        />
                        <div className="type">
                            <div className="percent">
                                <input
                                    type="radio"
                                    name="totalItemsPriceEffectType"
                                    value="percent"
                                    id="totalItemsPriceEffectPercent"
                                    form="effectForm"
                                    defaultChecked={
                                        this.updating
                                            ? effect &&
                                              effect.cart &&
                                              effect.cart.type == "percent"
                                            : true
                                    }
                                    onChange={this.effect_output}
                                />
                                <label htmlFor="totalItemsPriceEffectPercent">
                                    درصد
                                </label>
                            </div>
                            <div className="amount">
                                <input
                                    type="radio"
                                    name="totalItemsPriceEffectType"
                                    value="amount"
                                    id="totalItemsPriceEffectAmount"
                                    form="effectForm"
                                    defaultChecked={
                                        effect &&
                                        effect.cart &&
                                        effect.cart.type == "amount"
                                    }
                                    onChange={this.effect_output}
                                />
                                <label htmlFor="totalItemsPriceEffectPercent">
                                    تومان
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="effect packingCostEffect">
                        <i className="fa-solid fa-box"></i>
                        تخفیف روی هزینه بسته بندی
                        <input
                            type="number"
                            min={0}
                            name="packingCostEffectValue"
                            form="effectForm"
                            defaultValue={
                                this.updating
                                    ? effect &&
                                      effect.packing &&
                                      effect.packing.value
                                    : 0
                            }
                            onChange={this.effect_output}
                        />
                        <div className="type">
                            <div className="percent">
                                <input
                                    type="radio"
                                    name="packingCostEffectType"
                                    value="percent"
                                    id="packingCostEffectPercent"
                                    form="effectForm"
                                    defaultChecked={
                                        this.updating
                                            ? effect &&
                                              effect.packing &&
                                              effect.packing.type == "percent"
                                            : true
                                    }
                                    onChange={this.effect_output}
                                />
                                <label htmlFor="packingCostEffectPercent">
                                    درصد
                                </label>
                            </div>
                            <div className="amount">
                                <input
                                    type="radio"
                                    name="packingCostEffectType"
                                    value="amount"
                                    id="packingCostEffectAmount"
                                    form="effectForm"
                                    defaultChecked={
                                        effect &&
                                        effect.packing &&
                                        effect.packing.type == "amount"
                                    }
                                    onChange={this.effect_output}
                                />
                                <label htmlFor="packingCostEffectPercent">
                                    تومان
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="effect shippingCostEffect">
                        <i className="fa-solid fa-truck-fast"></i>
                        تخفیف روی هزینه ارسال
                        <input
                            type="number"
                            min={0}
                            name="shippingCostEffectValue"
                            form="effectForm"
                            defaultValue={
                                this.updating
                                    ? effect &&
                                      effect.shipping &&
                                      effect.shipping.value
                                    : 0
                            }
                            onChange={this.effect_output}
                        />
                        <div className="type">
                            <div className="percent">
                                <input
                                    type="radio"
                                    name="shippingCostEffectType"
                                    value="percent"
                                    id="shippingCostEffectPercent"
                                    form="effectForm"
                                    defaultChecked={
                                        this.updating
                                            ? effect &&
                                              effect.shipping &&
                                              effect.shipping.type == "percent"
                                            : true
                                    }
                                    onChange={this.effect_output}
                                />
                                <label htmlFor="shippingCostEffectPercent">
                                    درصد
                                </label>
                            </div>

                            <div className="amount">
                                <input
                                    type="radio"
                                    name="shippingCostEffectType"
                                    value="amount"
                                    id="shippingCostEffectAmount"
                                    form="effectForm"
                                    defaultChecked={
                                        effect &&
                                        effect.shipping &&
                                        effect.shipping.type == "amount"
                                    }
                                    onChange={this.effect_output}
                                />
                                <label htmlFor="shippingCostEffectPercent">
                                    تومان
                                </label>
                            </div>
                        </div>
                    </div>
                    {effectRes && (
                        <div className="output">
                            <div className="caption text secondary">
                                خروجی :
                            </div>
                            <div className="effect_output text primary">
                                {effectRes}
                            </div>
                        </div>
                    )}
                </div>
                <div className="settings">
                    <div className="caption">
                        <i className="fa-solid fa-gears"></i>تنظیمات
                    </div>

                    <div className="active">
                        <div className="caption">
                            <i className="fa-solid fa-thumbs-up"></i>
                            فعال باشد ؟
                        </div>
                        <input
                            type="checkbox"
                            name="active"
                            form="form"
                            defaultChecked={active}
                        />
                    </div>
                    <div className="expire">
                        <div className="top">
                            <div className="caption">
                                <i className="fa-solid fa-hourglass-end"></i>
                                زمان انقضا دارد ؟
                            </div>
                            <input
                                form="form"
                                type="checkbox"
                                name="hasExpire"
                                onChange={(ev) =>
                                    this.setState({
                                        hasExpire: ev.target.checked,
                                    })
                                }
                                defaultChecked={this.updating ? expire : false}
                            />
                        </div>
                        {hasExpire && (
                            <Fragment>
                                <div className="expireTime">
                                    <form
                                        id="expireForm"
                                        ref={this.expireFormRef}
                                    ></form>
                                    <input
                                        onChange={this.expire_output}
                                        type="number"
                                        name="hour"
                                        form="expireForm"
                                    />
                                    <span className="text info">ساعت</span>
                                    <input
                                        onChange={this.expire_output}
                                        type="number"
                                        name="day"
                                        form="expireForm"
                                    />
                                    <span className="text info">روز</span>
                                    <input
                                        onChange={this.expire_output}
                                        type="number"
                                        name="month"
                                        form="expireForm"
                                    />
                                    <span className="text info">ماه</span>
                                    <input
                                        onChange={this.expire_output}
                                        type="number"
                                        name="year"
                                        form="expireForm"
                                    />
                                    <span className="text info">سال </span>
                                    <span className="text secondary">
                                        {" "}
                                        دیگر از الان
                                    </span>
                                </div>
                                {expireRes && (
                                    <div className="res text primary">
                                        <div className="caption text secondary">
                                            زمان انقضا :
                                        </div>
                                        {expireRes}
                                    </div>
                                )}
                            </Fragment>
                        )}
                    </div>
                    <div className="limit">
                        <div className="caption">
                            <i className="fa-solid fa-hashtag"></i>
                            محدودیت تعداد استفاده
                        </div>
                        <input
                            type="number"
                            name="limit"
                            form="form"
                            defaultValue={limit}
                        />
                    </div>
                </div>
                <button className=" save confirm btn" onClick={this.save}>
                    ذخیره کد تخفیف
                </button>
            </div>
        );
    }
}

export default withRouter(Coupon);
